export const selectQIncidents = (state) => state.qIncidents;
